





































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ChallengeModel, Translated } from '@/models/challenge.model';
import { i18nModule } from '@/utils/store-acessor';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import CategoryCard from '@/components/Shared/CategoryCard.vue';
import { getCategories } from '@/models/category.model';

@Component({
  components: { CategoryCard }
})
export default class ChallengeHeader extends Vue {
  @Prop({ required: true }) challenge!: ChallengeModel;
  @i18nModule.Getter('locale') locale!: LocaleSelectorType;
  onuCategories!: any[];
  displayCategories: any[] = [];

  created() {
    if (this.locale.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
    this.getDisplayCategories();
  }

  @Watch('locale')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.displayCategories = [];
      this.onuCategories = getCategories('en');
      this.getDisplayCategories();
    } else {
      this.displayCategories = [];
      this.onuCategories = getCategories('br');
      this.getDisplayCategories();
    }
  }

  getDisplayCategories() {
    const categories = this.challenge.categories;
    if (!!categories && categories.length > 0) {
      this.displayCategories = this.onuCategories
        .filter((onuCategory) => !!categories
          .find(value => value.id == onuCategory.id))
    }
  }

  get challengeTitle(): string {
    const locale = this.locale.value;
    const title = this.challenge?.title as Translated;
    if (!!title) {
      switch (locale) {
        case 'en':
          // @ts-ignore
          return title.en || title;
        case 'ptBr':
          // @ts-ignore
          return title.pt || title;
      }
    }
    return '';
  }

  openCategory(slug: string) {
    this.$router.push(`/categories/${slug}`);
  }
}
